export default class Hub {
  constructor() {
    this.hubs = [];
  }
  registerListener(cb) {
    this.hubs.push(cb);
  }
  update(data) {
    return Promise.all(this.hubs.map(cb => cb(data)));
  }
  clearListeners() {
    this.hubs.length = 0;
  }
}
